<script setup lang="ts">
import { ref } from 'vue';
import { ElSelect, ElOption } from 'element-plus';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const props = withDefaults(defineProps<{
    list: string[];
    options: string[];
    placeholder?: string;
}>(), {
    placeholder: '',
});

const emits = defineEmits<{
    (event: 'change', value: string[]): void;
}>();

const activeList = ref(props.list);

function handleChange(value: string[]) {
    activeList.value = value;

    emits('change', value);
}
</script>

<template>
    <div class="recommend-selection flex">
        <ElSelect
            v-model="activeList"
            multiple
            filterable
            allowCreate
            defaultFirstOption
            popperClass="recommend-selection__popper"
            :placeholder="placeholder"
            :reserveKeyword="false"
            :showArrow="false"
            style="width: 100%"
            @change="handleChange"
        >
            <div class="recommend-selection-desc text-xs text-grey-450">
                {{ t('aiDisclosure.recommend') }}
            </div>

            <div class="flex">
                <ElOption
                    v-for="item in options"
                    :key="item"
                    :label="item"
                    :value="item"
                />
            </div>
        </ElSelect>
    </div>
</template>

<style lang="scss">
.recommend-selection {
    &__popper.el-popper {
        margin: 4px 0 !important;
        box-shadow: 0 0 4px 0 #00000014, 0 2px 6px 0 #00000014 !important;
        padding: 8px !important;

        .popper__arrow {
            display: none !important;
        }

        .el-select-dropdown__item,
        .el-select-dropdown__item:hover {
            width: unset !important;
            padding: 6px 8px !important;
            font-size: 14px !important;
            background: #f4f5f7 !important;
            margin: 8px 8px 0 0 !important;
            height: 28px !important;
            line-height: 16px !important;
            color: #000000 !important;
            font-weight: 400 !important;
        }

        .el-select-dropdown__item.selected {
            &::after {
                display: none;
            }
        }
    }

    .el-input__suffix {
        display: none !important;
    }

    .el-select__tags {
        .el-tag {
            @apply bg-grey-20;

            &.el-tag--info{
                @apply bg-grey-30;

                i {
                    @apply bg-grey-30;

                    &:before {
                        @apply bg-grey-30;
                        @apply text-grey-90 text-xs bg-grey-30 font-extrabold;
                    }
                }
            }
        }

        &-text {
            @apply text-black;
        }
    }
}

.confirm-dialog__body {
    textarea {
        &:focus-visible {
            outline: none !important;
            border-color: #0764E9;
        }
    }
}
</style>
